<template>
<div>
  <el-row>
    <el-col :span="6">
      <div class="grid-content"></div>
    </el-col>
    <el-col :span="2" style="border-bottom:1px solid #E1E5E8; line-height:35px">
      <div class="grid-content"><span><strong>发帖</strong></span></div>
    </el-col>
  </el-row>

  <el-row>
    <el-col :span="4">
      <div class="grid-content"></div>
    </el-col>

    <!-- <el-col :span="4" >
      <div  style="height:532px; background-color:white"></div>
    </el-col> -->

    <el-col :span="16" style="background-color:white; padding-left:10%; padding-right:10%;" >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  label-position="left">

        <el-form-item label="类别" prop="serviceType">
          <el-radio-group v-model="ruleForm.serviceType" size="mini">
            <el-radio-button v-for="item in type" :key="item.id" :label="item.id" :value="item.id">{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="服务分类" prop="options">
          <!-- <el-cascader :options="ruleForm.options" @active-item-change="handleItemChange" :props="servicesProps" size="mini"></el-cascader> -->
          <el-cascader v-model="ruleForm.options" :props="servicesProps" size="mini" style="width:100%"></el-cascader>

        </el-form-item>

        <el-form-item label="发帖人" prop="name" size="mini">
          <el-input v-model="ruleForm.name" placeholder="请输入发帖人姓名" disabled></el-input>
        </el-form-item>

        <el-form-item label="手机号码" prop="phone" size="mini">
          <el-input v-model="ruleForm.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="校区" prop="distName" size="mini">
          <el-select v-model="ruleForm.distName" placeholder="" style="width:100%">
            <el-option v-for="item in school" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="班级/部门" prop="dept" size="mini">
          <el-input v-model="ruleForm.dept" placeholder="" v-bind:disabled="ruleForm.hasDept===1"></el-input>
        </el-form-item>

        <el-form-item label="标题" prop="title" size="mini">
          <el-input v-model="ruleForm.title" placeholder="请输入标题" maxlength="15" show-word-limit rows="5"></el-input>
        </el-form-item>

        <el-form-item label="发帖内容" prop="content" size="mini">
          <el-input type="textarea" v-model="ruleForm.content" maxlength="200" show-word-limit rows="5"></el-input>
        </el-form-item>

        <el-form-item label="上传图片(最多可上传5张图片)" size="mini">
          <!-- <el-input type="textarea" v-model="ruleForm.iamge"></el-input> -->
     <!--     <el-upload class="upload-demo" :action="uploadUrl" name="multipartFiles" :on-preview="handlePreview" :on-success="handleAvatarSuccess" :on-remove="handleRemove" :file-list="ruleForm.image" list-type="picture" :limit=5>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传5张jpg/png文件，且不超过500kb</div>
          </el-upload>-->

          <van-uploader
            v-model="fileList"
             multiple
            :max-count="5"
            :before-read="beforeRead"
            :after-read="upload"
            :accept="'image/*'"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" size="mini">提交</el-button>
          <el-button @click="resetForm('ruleForm')" size="mini">重置</el-button>
        </el-form-item>

      </el-form>
    </el-col>


  </el-row>
  <el-footer></el-footer>


</div>
</template>

<script>
let id = 0;
import { getServiceItemByPid,addTiezi,OK,HOST} from '../../api/data.js'
import { Uploader } from 'vant';
import Exif from 'exif-js'

import Vue from 'vue'
import { Toast,MessageBox} from 'mint-ui';
Vue.use(Uploader);
export default {
  name: 'ComplaintsAndSuggestionsForm',
  data() {
    let _this = this
    //自定义验证器校验手机号码
    var checkPhone = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/;
      if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('手机号格式错误'))
      }
    };
    return {
      uploadUrl: '',
      userInfo: [],
      casAuthorization: '',
      servicesProps: {

        label: 'name',
        value: 'id',
        leaf: 'leaf',
        lazy: true,
        lazyLoad(node, resolve) {
          const {
            level
          } = node;
          if (node.level === 0) {
            getServiceItemByPid(id).then((res) => {
              resolve(res.data.data)
            }).catch(function(res) {
              console.log(res);
            })


          }

          if (node.level > 0) {
            getServiceItemByPid(node.data.id).then((res) => {
              resolve(res.data.data)
            }).catch(function(res) {
              console.log(res);
            })

          }
        }
      },
      type: [{
        id: 1,
        label: "投诉"
      }, {
        id: 2,
        label: "建议"
      }, {
        id: 3,
        label: "咨询"
      }, {
        id: 4,
        label: "表扬"
      }], //
      ruleForm: {
        name: '', //发帖人
        phone: '', //手机号码
        title: '', //标题
        content: '', //发帖内容
        serviceType: '', //帖子类型
        options: [],
        userId: '',
        userType: '',
        image: [],
        imageUrl: [],
        dept: '',
        distName: '',
        hasDept:0
      },
      fileList: [],
      files: {
        name: "",
        type: ""
      },
      serviceitemType:'',//定义分类一的默认值
      serviceitemId:'',
      username:'',//登录账号
      previewImg:'',
      isPreview: false,
      headerImage:'',
      picValue: null,
      school: [
        {id: '昆仑校区', name: '昆仑校区'},
        {id: '园湖校区', name: '园湖校区'},
        {id: '相思湖校区', name: '相思湖校区'}
      ],
      rules: {
        distName: [{
          required: true,
          message: '请选择校区',
          trigger: 'change'
        }],
        dept: [{
          required: true,
          message: '',
          trigger: 'blur'
        }],
        options: [{
          required: true,
          message: '请选择服务分类',
          trigger: 'change'
        }],
        name: [{
            required: true,
            message: '请输入发帖人',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 7,
            message: '长度在 2 到 5 个字符',
            trigger: 'blur'
          }
        ],
        serviceType: [{
          required: true,
          message: '请选择类别',
          trigger: 'change'
        }],
        title: [{
            required: true,
            message: '请填写标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 15,
            message: '长度在 15 个字符以内',
            trigger: 'blur'
          }
        ],
        content: [{
            required: true,
            message: '请填写发帖内容',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 200 个字符内',
            trigger: 'blur'
          }
        ],
        dept: [{
          required: true,
          message: '请填写班级或部门',
          trigger: 'blur'
        },
          {
            min: 1,
            max: 30,
            message: '长度在 30 个字符内',
            trigger: 'blur'
          }
        ],
        phone: [{
            required: true,
            message: '请填写手机号码',
            trigger: 'blur'
          },
          {
            validator: checkPhone,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  mounted() {
    let data = JSON.parse(localStorage.getItem("casUser"));
    console.log("mounted222222case");
    console.log(data);
    if (data) {
      let token = data.data.token
      //console.log("token:"+token);
      this.casAuthorization = token
      this.userInfo = data
      this.ruleForm.name = this.userInfo.data.studentName;
      if(this.userInfo.data.Telephone){
        this.ruleForm.phone = this.userInfo.data.Telephone

      }
      this.ruleForm.userType = this.userInfo.data.userType;
      this.ruleForm.userId = this.userInfo.data.id;
      this.username = this.userInfo.data.SID;
      if(this.userInfo.data.department){
        this.ruleForm.dept = this.userInfo.data.department
        this.ruleForm.hasDept =1
      }
      if(this.userInfo.data.ClassUnitName){
        this.ruleForm.dept = this.userInfo.data.ClassUnitName
        this.ruleForm.hasDept =1
      }
    } else {
      //未登录，跳转到登录页面
      this.$router.push('/pclogin')
    }
  },
  methods: {

    beforeRead(file) {
      if (file.type == 'image/jpeg'|| file.type == 'image/png') {
        return true;
      }else{
        Toast('请上传jpg或png 格式的图片');
        return false;
      }


    },
    async  upload(file) {
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.picValue = file.file; // 文件流
      this.imgPreview(this.picValue);
    },
    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, 'Orientation');
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否小于100K,是就直接上传，反之压缩图片
          if (this.result.length <= (100 * 1024)) {

            //self.headerImage = this.result;
            self.headerImage =self.headerImage +  "@"+ this.result;
          } else {
            img.onload = function () {
              let data = self.compress(img, Orientation);
              //self.headerImage = data;
              self.headerImage =self.headerImage+  "@"+ data
            }
          }
        }
      }
    },
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext('2d');
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = width * height / 4000000) > 1) {
        console.log("大于400万像素")
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = width * height / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6://需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas);
            break;
          case 8://需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas);
            break;
          case 3://需要180度旋转
            this.rotateImg(img, 'right', canvas);//转两次
            this.rotateImg(img, 'right', canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL('image/jpeg', 0.1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == 'right') {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = step * 90 * Math.PI / 180;
      let ctx = canvas.getContext('2d');
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    handleAvatarSuccess(response, file, fileList) {
      // console.log(response.data);
      this.ruleForm.imageUrl.push(response.data[0].url)
      // console.log(res);
      // alert(123)
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      // console.log(this.ruleForm.image);
    },
    handlePreview(file) {
      // console.log(file);
      // console.log(this.ruleForm.image);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.ruleForm.options += ''
          this.ruleForm.userId = this.userInfo.data.studentID
          this.ruleForm.image += ''
          this.ruleForm.userType = 1

          if(this.ruleForm.options!=null){
            this.serviceitemType = this.ruleForm.options.split(",")[0];
            this.serviceitemId = this.ruleForm.options.split(",")[1];
          }

          // console.log(this.casAuthorization);
          let _this = this

          //没有上传图片情况
         if(this.headerImage === ''){
         addTiezi(this.ruleForm.userId,this.ruleForm.name,this.ruleForm.phone,
              this.ruleForm.serviceType,this.ruleForm.userType,this.username,this.serviceitemType,
              this.serviceitemId,this.ruleForm.title,this.ruleForm.distName,this.ruleForm.content,this.ruleForm.dept,"").then(res=>{
              if(res.status === OK) {
                if(res.data.success==true){
                  this.$toast({
                    message: '发帖成功',
                    duration: 500
                  })
                  this.$router.push({
                    path: '/mine'
                  })

                }else{
                  Toast('发帖失败！')
                }
              }
            }).catch(error=>{
              this.isDisable = false;//开始可以点击
              console.log("错误"+error);
            })

          }else {
            addTiezi(this.ruleForm.userId,this.ruleForm.name,this.ruleForm.phone,
              this.ruleForm.serviceType,this.ruleForm.userType,this.username,this.serviceitemType,
              this.serviceitemId,this.ruleForm.title,this.ruleForm.distName,this.ruleForm.content,this.ruleForm.dept,this.headerImage).then(res=>{
              if(res.status === OK) {
                if(res.data.success==true){
                  this.$toast({
                    message: '发帖成功',
                    duration: 500
                  })
                  this.$router.push({
                    path: '/mine'
                  })

                }else{
                  Toast('发帖失败！')
                }
              }
            }).catch(error=>{

              console.log("错误"+error);
            })

          }

        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

  },

}
</script>


<style scoped>
.form_border {
  /* border: 1px solid grey; */
  /* padding: 5px; */
  /* border-radius: 10px; */
}

.content {
  /* background: #FBFBFB */
}
</style>



// WEBPACK FOOTER //
// src/components/pc/ComplaintsAndSuggestionsForm.vue